import { useTranslation } from "react-i18next";
import { AuthCard } from "@/components/auth/AuthCard";
import { SignupForm } from "@/components/auth/SignupForm";

export function SignupPage() {
  const { t } = useTranslation("auth");
  return (
    <AuthCard title={t("signup.title")} description={t("signup.description")}>
      <SignupForm />
    </AuthCard>
  );
}
